import { connect } from 'react-redux'
import NumbersTwilioUploadDocumentsStep from './NumbersTwilioUploadDocumentsStep'
import { uploadTwilioDocument } from '../../Files/Files.actions'

const mapStateToProps = ({ files }) => {
  const name = 'twilioUploadDocumentsStep'
  const file = files[name] || {}
  return {
    loading: file.loading || false,
    name,
  }
}

const dispatchToProps = {
  uploadTwilioDocument,
}

export default connect(mapStateToProps, dispatchToProps)(NumbersTwilioUploadDocumentsStep)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersTwilioUploadDocumentsStep/NumbersTwilioUploadDocumentsStep.container.js